import React from 'react'
import { Pressable, StyleSheet, Text, View } from 'react-native'
import { DS } from '@/design-system'

export type PillPickerOption<T> = {
  label: string
  value: T
}

type PillPickerProps<T> = {
  options: PillPickerOption<T>[]
  value: T
  onChange: (value: T) => void
}

/**
 * Thin pill row used by the create-game and create-tournament forms.
 * Same visual language as the new-game pickers: 1px light-grey border,
 * black fill when selected, options share the row width evenly.
 */
export function PillPicker<T extends string | number | undefined>({ options, value, onChange }: PillPickerProps<T>) {
  return (
    <View style={styles.container}>
      {options.map((opt) => {
        const selected = opt.value === value
        return (
          <Pressable
            key={String(opt.value)}
            onPress={() => onChange(opt.value)}
            style={[styles.pill, selected && styles.pillSelected]}
          >
            <Text style={[styles.label, selected && styles.labelSelected]} numberOfLines={1}>
              {opt.label}
            </Text>
          </Pressable>
        )
      })}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 8
  },
  pill: {
    flex: 1,
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 50,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    alignItems: 'center'
  },
  pillSelected: {
    backgroundColor: DS.palette['Global/Black']
  },
  label: {
    fontSize: 14,
    color: DS.palette['Global/Black']
  },
  labelSelected: {
    color: DS.palette['Global/White']
  }
})
